/**
 * This file contains CSS constants that need to be accessed in TypeScrop code.
 */

 /**
  * Breakpoint that determines the screen width at which a dropdown modal that is centered on the screen should be shown
  * (instead of a list of items below the dropdown).
  */
export const dropdownModalBreakpoint = '500px';

/**
 * Breakpoints according to bootstrap (xs < 576 px)
 */
export const BootstrapBreakpoints = {
  xl: '1200px',
  lg: '992px',
  md: '768px',
  sm: '576px',
};
